import { get, post } from '@kit/utils/APIV1.js'
import { recaptchaTokenize } from '@kit/utils/Recaptcha'

export const page = async() => {
  return get(`refer-to-us-page/id/68`)
}

//https://localhost/cms-service/index.php/wp-json/v1/referral-form-endpoint
export const referralFormEndpoint = async(jsonFormData) => {
  await recaptchaTokenize(jsonFormData, 'referral')
  return post(`referral-form-endpoint`, jsonFormData)
}